import styles from './SignatureStatus.scss';

export function SignatureStatus({total=0, pending=0, canceled=0}) {
    const completedSignatures = total - pending - canceled;
    if(total === 0 || (completedSignatures === 0 && canceled > 0)){
        return NoSignaturesRequested;
    }
    if(pending === 1){
        return OneSignatureOutstanding;
    }
    if(pending > 1){
        return MultipleSignaturesOutstanding(pending);
    }

    return SignaturesComplete;
}

const NoSignaturesRequested = <p className={styles.signatureStatus__none}> NO SIGNATURES REQUESTED </p>;

const SignaturesComplete = <p className={styles.signatureStatus__complete}> SIGNATURES COMPLETE </p>;

const OneSignatureOutstanding = <p className={styles.signatureStatus__outstanding}> 1 SIGNATURE OUTSTANDING </p>;

const MultipleSignaturesOutstanding = (pendingSignaturesCount) =>
    <p className={styles.signatureStatus__outstanding}>
        {`${pendingSignaturesCount} SIGNATURES OUTSTANDING`}
    </p>;
